/**
 * Select — DS Atom
 */

import styles from './Select.module.css';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  label?: string;
  options: SelectOption[];
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  className?: string;
}

export function Select({
  label, options, value, onChange, error, disabled = false,
  placeholder, id, className = '',
}: SelectProps) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {label && <label className={styles.label} htmlFor={id}>{label}</label>}
      <select
        id={id}
        className={`${styles.select} ${error ? styles.selectError : ''}`}
        value={value}
        onChange={e => onChange?.(e.target.value)}
        disabled={disabled}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
}
